import React from 'react';
import { FacebookIcon, TwitterIcon, InstagramIcon, LinkedinIcon, MailIcon, PhoneIcon, MapPinIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-950 text-gray-300 pt-16 pb-8 border-t border-gray-800" data-id="element-31">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-32">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-33">
          {/* Company Info */}
          <div className="lg:col-span-1" data-id="element-34">
            <a href="#" className="text-3xl font-extrabold tracking-tighter flex items-center mb-6" data-id="element-35">
              <span className="text-white" data-id="element-36">ad</span>
              <span className="text-red-600" data-id="element-37">ROI</span>
            </a>
            <p className="text-gray-400 mb-6 text-sm leading-relaxed" data-id="element-38">
              Marketing Experts at Driving & Turning Traffic into Conversions
              with a Focus on Building Customer Loyalty & Retention.
            </p>
            <div className="space-y-3 text-sm" data-id="element-39">
              <a href="tel:17022134801" className="flex items-center hover:text-white transition-colors" data-id="element-40">
                <PhoneIcon className="w-4 h-4 mr-3 text-gray-500" data-id="element-41" />
                (702) 213-4801
              </a>
              <a href="mailto:Results@GetAdROI.com" className="flex items-center hover:text-white transition-colors" data-id="element-42">
                <MailIcon className="w-4 h-4 mr-3 text-gray-500" data-id="element-43" />
                Results@GetAdROI.com
              </a>
              <div className="flex items-start" data-id="element-44">
                <MapPinIcon className="w-4 h-4 mr-3 text-gray-500 mt-1 flex-shrink-0" data-id="element-45" />
                <span data-id="element-46">
                  Las Vegas, NV
                  <br data-id="element-47" />
                  Serving Clients Nationwide
                </span>
              </div>
            </div>
          </div>

          {/* Services */}
          <div data-id="element-48">
            <h4 className="text-white font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-49">
              Services
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-50">
              <li data-id="element-51">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-52">
                  Search Engine Optimization
                </a>
              </li>
              <li data-id="element-53">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-54">
                  Pay-Per-Click Advertising
                </a>
              </li>
              <li data-id="element-55">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-56">
                  Web Design & Development
                </a>
              </li>
              <li data-id="element-57">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-58">
                  CRM Implementation
                </a>
              </li>
              <li data-id="element-59">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-60">
                  Conversion Rate Optimization
                </a>
              </li>
              <li data-id="element-61">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-62">
                  Social Media Marketing
                </a>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div data-id="element-63">
            <h4 className="text-white font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-64">
              Company
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-65">
              <li data-id="element-66">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-67">
                  About Us
                </a>
              </li>
              <li data-id="element-68">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-69">
                  Our Process
                </a>
              </li>
              <li data-id="element-70">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-71">
                  Case Studies
                </a>
              </li>
              <li data-id="element-72">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-73">
                  Careers
                </a>
              </li>
              <li data-id="element-74">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-75">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div data-id="element-76">
            <h4 className="text-white font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-77">
              Resources
            </h4>
            <ul className="space-y-3 text-sm mb-6" data-id="element-78">
              <li data-id="element-79">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-80">
                  Marketing Blog
                </a>
              </li>
              <li data-id="element-81">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-82">
                  ROI Calculator
                </a>
              </li>
              <li data-id="element-83">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-84">
                  Free SEO Audit
                </a>
              </li>
              <li data-id="element-85">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-86">
                  Help Center
                </a>
              </li>
            </ul>
            <h4 className="text-white font-bold mb-4 uppercase tracking-wider text-sm" data-id="element-87">
              Follow Us
            </h4>
            <div className="flex space-x-4" data-id="element-88">
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-89">
                <FacebookIcon className="w-5 h-5" data-id="element-90" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-91">
                <TwitterIcon className="w-5 h-5" data-id="element-92" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-93">
                <InstagramIcon className="w-5 h-5" data-id="element-94" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-95">
                <LinkedinIcon className="w-5 h-5" data-id="element-96" />
              </a>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center text-xs text-gray-500" data-id="element-97">
          <p data-id="element-98">
            &copy; {new Date().getFullYear()} AdROI Marketing & Conversions. All
            rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-99">
            <a href="#" className="hover:text-white transition-colors" data-id="element-100">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-101">
              Terms of Service
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-102">
              Cookie Policy
            </a>
          </div>
        </div>
      </div>
    </footer>;
}